import { useEffect, useState } from 'react';
import { MdOutlineAddBox } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useCurrent, useDelete, useFetch } from '../../hooks';
import SearchVendor from '../SearchVendor';
import {
    ConfirmDelete,
    MwButton,
    MwSpinner,
} from '../ui';
import NoDataFound from '../ui/NoDataFound';
import CardHeadeWithActions from '../ui/CardHeadeWithActions';
import ListVendorsItem from './ListVendorsItem';

const ListVendors = ({ setMode, idItemSelected, setIdItemSelected }) => {
    const [t] = useTranslation('global');
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
    const [vendorsList, setVendorsList] = useState();
    const { data: deleteResult, deleteItem } = useDelete();
    const {
        data: dataCustomers,
        loading,
        refreshHandler,
    } = useFetch(
        `${process.env.REACT_APP_VENDORS_API_BASE_URL}/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
    );

    const onChangeSearch = (newValue) => {
        if (newValue.length === 0) {
            refreshHandler();
        }

        setVendorsList(newValue);
    };

    const editHandeler = (id) => {
        setIdItemSelected(id);
        setMode('Edit');
    };

    const deleteHandeler = (id) => {
        setIdItemSelected(id);
        setShowConfirmDelete(true);
    };

    const confirmDelete = () => {
        deleteItem(`${process.env.REACT_APP_VENDORS_API_BASE_URL}/delete/${idItemSelected}`);
    };

    useEffect(() => {
        if (dataCustomers) {
            setVendorsList(dataCustomers.data);
        }
    }, [dataCustomers]);

    useEffect(() => {
        if (deleteResult) {
            refreshHandler();
            setShowConfirmDelete(false);
        }
    }, [deleteResult, refreshHandler]);

    return (
        <>
            <ConfirmDelete
                onDeleteHandler={confirmDelete}
                onShow={showConfirmDelete}
                setOnShow={setShowConfirmDelete}
                msg={t('vendors.confirmDelete')}
            />

            <div>
                <CardHeadeWithActions title={t('vendors.vendorsList')}>
                    <div className='w-full lg:w-[320px]'>
                        <SearchVendor
                            className='bg-white'
                            isOpen={false}
                            onChangeSearch={onChangeSearch}
                        />
                    </div>
                    <MwButton inGroup={true} type='saveBtn' onClick={() => setMode('Add')}>
                        <MdOutlineAddBox size={18} />
                        {t('vendors.addNewVendor')}
                    </MwButton>
                </CardHeadeWithActions>

                <div className='my-3'>
                    {loading && <MwSpinner />}

                    {!loading && vendorsList && vendorsList.length > 0 ? (
                        <div className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm'>
                            <div className='max-h-[calc(100vh-280px)] overflow-auto custom-scrollbar'>
                                <table className='min-w-[840px] w-full border-collapse'>
                                    <thead className='sticky top-0  bg-slate-100 text-xs uppercase tracking-wide text-slate-500'>
                                        <tr>
                                            <th className='px-3 py-3 text-center font-semibold'>#</th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('vendors.vendorNumber')}
                                            </th>
                                            <th className='px-3 py-3 text-start font-semibold'>
                                                {t('vendors.vendorName')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('vendors.mobileNumber')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('common.date')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('product.status')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('table.actions')}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {vendorsList.map((item, index) => (
                                            <ListVendorsItem
                                                key={item._id}
                                                index={index + 1}
                                                item={item}
                                                deleteHandeler={deleteHandeler}
                                                editHandeler={editHandeler}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        !loading && <NoDataFound msg={t('vendors.noVendorsFound')} />
                    )}
                </div>
            </div>
        </>
    );
};

export default ListVendors;
